import { OpenSubmissionsElement } from 'communication/types/openSubmissions/OpenSubmissionsElement';
import { WidgetType } from 'widgets/WidgetType';
import {
    WidgetTypeActionPayload,
    WidgetTypeAction,
} from 'widgets/store/actions';
import {
    createReceiveMessageAction,
    createClearStreamDataAction,
    createWatchStreamAction,
    WidgetClearStreamDataAction,
    WidgetStreamMessageReceiveAction,
    WidgetStreamMessageReceivePayload,
    WidgetStreamActionPayload,
} from 'widgets/store/stream/actions';

export type OpenSubmissionStreamWidgetType =
    | WidgetType.OPEN_SUBMISSIONS
    | WidgetType.OPEN_SUBMISSIONS_CAPSULE;

export enum OpenSubmissionsStreamActionType {
    OPEN_SUBMISSIONS_START_FADE_OUT = 'OPEN_SUBMISSIONS_START_FADE_OUT',
    OPEN_SUBMISSIONS_REMOVE_SUBMISSION = 'OPEN_SUBMISSIONS_REMOVE_SUBMISSION',
}

export interface OpenSubmissionsWidgetStreamPayload
    extends WidgetTypeActionPayload {
    submissionKey: number;
}

type OpenSubmissionsFadeOutAction = WidgetTypeAction<
    OpenSubmissionsWidgetStreamPayload,
    OpenSubmissionsStreamActionType.OPEN_SUBMISSIONS_START_FADE_OUT
>;

export function openSubmissionsFadeOutAction(
    widgetType: OpenSubmissionStreamWidgetType,
    widgetKey: string,
    submissionKey: number
): OpenSubmissionsFadeOutAction {
    return {
        type: OpenSubmissionsStreamActionType.OPEN_SUBMISSIONS_START_FADE_OUT,
        payload: {
            widgetType,
            widgetKey,
            submissionKey,
        },
    };
}

type OpenSubmissionsRemoveSubmissionAction = WidgetTypeAction<
    OpenSubmissionsWidgetStreamPayload,
    OpenSubmissionsStreamActionType.OPEN_SUBMISSIONS_REMOVE_SUBMISSION
>;

export function removeSubmissionAction(
    widgetType: OpenSubmissionStreamWidgetType,
    widgetKey: string,
    submissionKey: number
): OpenSubmissionsRemoveSubmissionAction {
    return {
        type: OpenSubmissionsStreamActionType.OPEN_SUBMISSIONS_REMOVE_SUBMISSION,
        payload: {
            widgetType,
            widgetKey,
            submissionKey,
        },
    };
}

export const receiveMessageAction = (
    widgetType: OpenSubmissionStreamWidgetType
) => createReceiveMessageAction<OpenSubmissionsElement>(widgetType);

export const clearOpenSubmissionsStreamData = (
    widgetType: OpenSubmissionStreamWidgetType
) => createClearStreamDataAction(widgetType);

export const watchOpenSubmissionsStreamAction = (
    widgetType: OpenSubmissionStreamWidgetType
) => createWatchStreamAction(widgetType);

export type OpenSubmissionsWidgetStreamAction =
    | OpenSubmissionsFadeOutAction
    | OpenSubmissionsRemoveSubmissionAction;

export type OpenSubmissionsStreamActionPayload =
    | WidgetTypeActionPayload
    | WidgetStreamActionPayload
    | OpenSubmissionsWidgetStreamPayload
    | WidgetStreamMessageReceivePayload<OpenSubmissionsElement>;

export type OpenSubmissionsStreamAction =
    | WidgetClearStreamDataAction
    | OpenSubmissionsWidgetStreamAction
    | WidgetStreamMessageReceiveAction<OpenSubmissionsElement>;
